import React, { useState, useEffect, useContext } from 'react';
import Axios from 'axios';
import queryString from 'query-string';
import styled from 'styled-components';
import { Revisions } from '../../../../components/TextEditor/revisions';
import PrivatePage, { menuItemObj } from '../../../../components/PrivatePage';
import Tooltip from '../../../../CustomTooltip';
import { get, post } from '../../../../lib/api';
import GenericError from '../../../../components/GenericError';
import Loader from '../../../../components/Loader';
import SaveIcon from '../../../../components/Images/Save';
import { getAudiobookWordCountLimit } from './helpers';
import { isAdminAccess } from '../../../../config';
import { Provider } from '../../../../context/editorContext';
import { BackButton as Back } from '../../../../components/WithSubHeaderBG';
import History from '../../../../components/Images/History';
import Undo from '../../../../components/Images/Undo';
import Redo from '../../../../components/Images/Redo';
import WordCount from '../../../../components/Images/WordCount';
import { PrimaryButton, SecondaryButton } from '../../../../components/Button';
// import {
//   Tool,
//   ToolInfo,
//   ToolContainer,
// } from '../../../../components/TextEditor/styles'
import {
  TextEditor,
  getContent,
  isContentChanged,
  isUndoEmpty,
  isRedoEmpty,
  handleRedo as onRedo,
  handleUndo as onUndo,
} from '../../../../components/TextEditor';
import Vellip from '../../../../components/Images/Vellip';
import { Box, Text } from '../../../../designSystem';
import { novelChapterWordCount } from '../../../../constants';
import AlertSnackBar from '../../../../components/AlertSnackBar';
import writeIcon from './writing-hand-light-skin-tone.svg';
import { handleNotionOrExternalLink } from '../../../../lib/utils';
import ArrowLeft from '../../../../components/Images/ChevronLeft';
import ThreeDotsDropdownMenu from './ThreeDotsDropdownMenu';
import ClickOutside from '../../../../components/common/utility/ClickOutside';
import ShareIcon from '../../../../components/Images/ShareIcon';
import SharePopup from './SharePopup';
import { ControlsContext } from '../../../../providers/controlsProvider';
import { handleNewEventLog } from '../../../../lib/utils/events';
import ShareNotification from '../../../../components/Images/ShareNotification';

const ControlsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85%;
  align-items: center;
  background-color: ${({ showTitle }) => showTitle && 'white'};
  @media (max-width: 600px) {
    width: 100%;
  }
`;
const LeftDiv = styled.div`
  padding: 8px 0 8px 48px;

  @media (max-width: 600px) {
    padding: 8px 0 8px 0px;
  }
`;
const RightDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 160px;
  padding-top: 8px;
  align-items: center;

  @media (max-width: 600px) {
    padding: 0;
  }
`;
const TopDiv = styled.div`
  display: flex;
  align-items: center;
  svg: {
    margin-right: 8px;
  }
`;

const BackIconWordCountWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const BottomDiv = styled.div`
  /* @media (max-width: 600px) {
    display: none;
  } */
`;
const TitleInput = styled.input`
  width: 30vw;
  padding: 8px;
  font-size: 16px;
  line-height: 1.3;
  text-align: left;
  color: var(--Text700);
  border-radius: 4px;
  border: ${({ isError }) =>
    isError ? 'solid 1px red' : '2px solid var(--Grey300)'};
  @media (max-width: 600px) {
    width: ${({ isUgcBook }) => (isUgcBook ? '120px' : '150px')};
    margin: 8px 0;
    margin-left: 16px;
  }
`;

const BackButton = styled(Back)`
  margin-right: 8px;
`;

const GuideRef = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  text-decoration: underline !important;
  gap: 4px;
  cursor: pointer;
  color: blue;
`;

const PrefixStr = styled.div`
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: var(--Text500);
  margin-right: 4px;
  font-weight: bold;
`;
const ButtonWrapper = styled.div`
  margin-left: 16px;

  button {
    border-radius: 24px;
  }
`;

const ShareIconWrapper = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.showShareNotification ? '#ffffff' : '#ededed'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.isDisabled ? '0.5' : '1')};
  position: relative;
  box-shadow: ${(props) =>
    props.showShareNotification ? 'rgb(75, 183, 254) 0px 0px 8px 0px' : 'none'};
`;

const StyledTriangle = styled.div`
  position: absolute;
  top: 42px;
  right: 8px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 10px solid #4bb7fe;
`;

const VellipContainer = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  // background-color: #ebecf1;
  position: relative;
  cursor: pointer;
`;

const ThreeDotsDropdownWrapper = styled.div`
  position: absolute;
  top: 152%;
  right: 38%;

  @media (max-width: 600px) {
    top: 132%;
    right: 20%;
  }
`;

const StyledShareNotificationWrapper = styled.div`
  position: absolute;
  top: 50px;
  right: -8px;
  background-color: #4bb7fe;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  width: max-content;

  @media (max-width: 600px) {
    width: calc(100vw - 32px);
    transform: translateX(11%);
    right: -11%;
  }
`;

const StyledShareNotifcationTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledShareHeading = styled.p`
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #ffffff;
`;

const StyledShareSubHeading = styled.p`
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #ffffff;
`;

const WriteImg = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 4px;
`;

const BackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Tool = styled.span`
  display: flex;
`;

const ToolContainer = styled.div`
  display: flex;
`;

const ToolInfo = styled.span`
  color: rgba(13, 21, 54, 0.65);
  margin-right: 16px;
  font-weight: bold;

  span {
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: #38a1e8;
  }

  .words-text {
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: #b5b5b5;
  }
`;

const MinimumText = styled.p`
  font-family: Noto Sans;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  color: #b5b5b5;
`;

const ChapterTitleWrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.isFirstChapterPublishBonus ? '256px' : '152px')};
  left: calc(50vw - 458px);
  max-width: 912px;
  width: 912px;

  @media (max-width: 600px) {
    position: static;
    width: max-content;
    max-width: 280px;
  }
`;

const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 14px;
  margin-left: 18px;

  label {
    font-family: Noto Sans;
    font-size: 10px;
    font-weight: 700;
    line-height: 12px;
    color: #797979;
    height: 12px;
  }

  span {
    font-weight: 400;
  }

  label.title-error {
    color: #ff0000;
  }

  input {
    outline: none;
    border: none;
    font-family: Noto Sans;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    color: #38a1e8;

    ::placeholder {
      color: #c0c0c0;
    }
  }
`;

export const EditorControls = ({
  isUgcBook,
  title: titleParam,
  tab,
  showTitle = false,
  chapterCount,
  action,
  regex,
  onBack,
  onTitleChange,
  wordCount,
  undoActive,
  redoActive,
  handleUndo,
  handleRedo,
  showRevisionsIcon,
  handleShowRevision,
  toggleRevisionsSideDrawer,
  showShareNotification,
  setShowShareNotification,
  user,
  setEmptyTitleError,
  emptyTitleError,
  novelDetails,
  chapter_id,
  chapterDetails,
  actionButtons: { primary, secondary } = {},
  isFirstChapterPublishBonus,
  wordLimit,
  boostingWordCountVariant = 'A',
  isNavMenuOpen,
  setNavMenuOpen,
  isShortStory,
  showSharePopUpOpen,
  setShowSharePopupOpen,
}) => {
  const [isMobileOptionsShowing, setIsMobileOptionsShowing] = useState(false);
  const { setChangeNavZIndex } = useContext(ControlsContext);
  const [showInputError, setInputError] = useState(false);
  const [titleError, toggleTitleError] = useState(false);

  const isMobile = window.screen.width < 600;
  let title = titleParam;
  let prefix = '';
  let prefixStart = '';
  let prefixEnd = '';
  let prefixChapterNumber = '';
  let newChapterPrefix = '';
  if (regex) {
    const result = titleParam.match(regex);
    if (result) {
      prefix = result[0];
      title = titleParam.replace(regex, '');
      const ResultStrArr = prefix.match(/\s\d+\s/);
      const numberMatchStr = ResultStrArr[0];
      newChapterPrefix = `Chapter ${numberMatchStr}`;
      prefixChapterNumber = numberMatchStr.trim();
      const prefixArr = prefix.split(prefixChapterNumber);
      prefixStart = prefixArr[0];
      prefixEnd = prefixArr[1];
    }
  }

  const handleTitleChange = (title) => {
    onTitleChange(prefix + title);
  };
  const handlePrefixChange = (e) => {
    const number = e.target.value;
    if (!number) return;
    const newPrefix = prefixStart + number + prefixEnd;
    onTitleChange(newPrefix + title);
  };

  const wordCountSubHeading = () => {
    let subHeader = '';
    const el = document.getElementById('word-count-text');
    if (wordCount < wordLimit) {
      subHeader = `Minimum ${wordLimit}`;
      if (el) el.style.color = 'red';
    } else {
      subHeader = wordCount > 5000 ? 'Reduce to 5000' : 'Maximum 5000';
      if (el) el.style.color = wordCount > 5000 ? 'red' : 'green';
    }
    return subHeader;
  };

  const handlePrimaryClick = () => {
    if (primary?.label === 'Publish') {
      if (
        title.toLowerCase() === 'untitled chapter' ||
        title.toLowerCase() === 'chapter title'
      ) {
        toggleTitleError(true);
        setInputError(true);
      } else {
        primary.onClick();
      }
    } else {
      primary.onClick();
    }
  };

  const countText = `Chapter ${parseInt(chapterCount) + 1}`;

  return (
    <>
      <ControlsDiv showTitle={showTitle}>
        <LeftDiv>
          <TopDiv>
            <BackIconWordCountWrapper>
              {!showTitle && (
                <BackButtonWrapper onClick={onBack}>
                  <ArrowLeft fill="#38A1E8" />
                </BackButtonWrapper>
              )}
              {!isAdminAccess && (
                <ChapterTitleWrapper
                  isFirstChapterPublishBonus={isFirstChapterPublishBonus}
                >
                  {/* {!showTitle && (
                    <PrefixStr>
                      {action !== 'add-chapter'
                        ? prefix
                        : `Ch ${parseInt(chapterCount) + 1} `}
                    </PrefixStr>
                  )} */}
                  {!isMobile && (
                    <StyledInputWrapper>
                      <label
                        className={
                          emptyTitleError && title.length === 0
                            ? 'title-error'
                            : ''
                        }
                      >
                        {isShortStory ? 'Story title' : newChapterPrefix ||
                          `Chapter ${parseInt(chapterCount) + 1}`}
                        {emptyTitleError && title.length === 0 && (
                          <span>{` (Please enter title)`}</span>
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder="Enter title here..."
                        value={title}
                        onChange={(e) => handleTitleChange(e.target.value)}
                      />
                    </StyledInputWrapper>
                  )}
                  {showTitle && (
                    <StyledInputWrapper>
                      <label
                        className={
                          emptyTitleError && title.length === 0
                            ? 'title-error'
                            : ''
                        }
                      >
                        {isShortStory ? 'Story title' : newChapterPrefix ||
                          `Chapter ${parseInt(chapterCount) + 1}`}
                        {emptyTitleError && title.length === 0 && (
                          <span>{` (Please enter title)`}</span>
                        )}
                      </label>
                      <input
                        type="text"
                        placeholder="Enter title here..."
                        value={title}
                        onChange={(e) => handleTitleChange(e.target.value)}
                      />
                    </StyledInputWrapper>
                  )}
                </ChapterTitleWrapper>
              )}
              {!showTitle && (
                <BottomDiv>
                  <Tool>
                    <ToolInfo>
                      <span className="notranslate">{wordCount} </span>
                      <span className="words-text">
                        {wordCount > 1 ? 'words' : 'word'}
                      </span>
                    </ToolInfo>
                  </Tool>
                  <MinimumText id="word-count-text">
                    {wordCountSubHeading()}
                  </MinimumText>
                </BottomDiv>
              )}
            </BackIconWordCountWrapper>
          </TopDiv>
        </LeftDiv>
        <RightDiv>
          {primary && primary.show && (
            <ButtonWrapper>
              <PrimaryButton
                active={primary.enabled}
                onClick={handlePrimaryClick}
                disabled={!primary?.enabled}
              >
                <span>{primary.label}</span>
              </PrimaryButton>
            </ButtonWrapper>
          )}
          {!showTitle &&
            novelDetails?.share_feature_variant === 'B' &&
            chapterDetails?.result?.status !== 'published' && (
              <ShareIconWrapper
                showShareNotification={showShareNotification}
                isDisabled={wordCount === 0}
                onClick={() => {
                  if (wordCount === 0) {
                    return;
                  }
                  handleNewEventLog(
                    'chapter_editor',
                    'novels_draft_chapter_share_clicked',
                    {
                      route: window.location.pathname + window.location.search,
                      module_name: 'novels_draft_chapter_share_clicked',
                      button: 'share_icon',
                      entity_id: chapter_id || 'Null',
                      entity_type: 'chapter',
                    },
                    user,
                    novelDetails
                  );
                  setChangeNavZIndex(true);
                  secondary.onClick('is_share_feature');
                }}
              >
                <ShareIcon
                  fill={
                    showShareNotification && chapter_id ? '#38a1e8' : '#474747'
                  }
                />
                {showShareNotification && chapterCount === 0 && (
                  <>
                    <StyledTriangle />
                    <StyledShareNotificationWrapper
                      onClick={() => {
                        setShowSharePopupOpen(true);
                        setShowShareNotification(false);
                        handleNewEventLog(
                          'chapter_editor',
                          'novels_draft_chapter_share_clicked',
                          {
                            route:
                              window.location.pathname + window.location.search,
                            module_name: 'novels_draft_chapter_share_clicked',
                            button: 'share_icon',
                            entity_id: chapter_id || 'Null',
                            entity_type: 'chapter',
                          },
                          user,
                          novelDetails
                        );
                      }}
                    >
                      <ShareNotification />
                      <StyledShareNotifcationTextWrapper>
                        <StyledShareHeading>
                          Unlock instant feedback!
                        </StyledShareHeading>
                        <StyledShareSubHeading>
                          Share your content with friends and family
                        </StyledShareSubHeading>
                      </StyledShareNotifcationTextWrapper>
                    </StyledShareNotificationWrapper>
                  </>
                )}
              </ShareIconWrapper>
            )}
          <SharePopup
            isVisible={showSharePopUpOpen}
            chapterId={chapter_id ?? ''}
            userLanguage={novelDetails.language}
            userName={user.fullname}
            title={title}
            bookId={novelDetails.book_id}
            user={user}
            novelDetails={novelDetails}
            close={() => {
              setShowSharePopupOpen(false);
              setChangeNavZIndex(false);
            }}
          />
          {!showTitle && !isShortStory &&(
            <VellipContainer>
              <Vellip
                onClick={() => {
                  handleNewEventLog(
                    'chapter_editor',
                    'novels_chapter_three_dots_clicked',
                    {
                      route: window.location.pathname + window.location.search,
                      module_name: 'chapter_editor_three_dots_menu',
                      button: 'three_dots_icon',
                      entity_id: chapter_id || 'Null',
                      entity_type: 'chapter',
                    },
                    user,
                    novelDetails
                  );
                  setNavMenuOpen(!isNavMenuOpen);
                }}
              />
              {isNavMenuOpen && (
                <ClickOutside onClose={() => setNavMenuOpen(false)}>
                  <ThreeDotsDropdownWrapper>
                    <ThreeDotsDropdownMenu
                      saveOptions={secondary}
                      toggleRevisionsSideDrawer={toggleRevisionsSideDrawer}
                      showRevisionsIcon={showRevisionsIcon}
                      user={user}
                      novelDetails={novelDetails}
                      chapter_id={chapter_id}
                      getContent={getContent}
                      title={title}
                    />
                  </ThreeDotsDropdownWrapper>
                </ClickOutside>
              )}
            </VellipContainer>
          )}
        </RightDiv>
        {titleError && (
          <AlertSnackBar
            bottomMobile="60px"
            closeBtn={true}
            text={'Kindly Update Your Chapter Title'}
            close={() => toggleTitleError(false)}
          />
        )}
      </ControlsDiv>
    </>
  );
};

export default EditorControls;
